import { environment } from '@brighthub/environment';

/**
 * Group names are defined here; features consume these constants. UAT uses prod groups.
 * Okta group name carried on the access token `groups` claim for BrightNav environment admins.
 * Used for broader operator features (e.g. searched conversations, employee tools) via
 * `authGroupGuard` and menu `groups`.
 *
 * @remarks The **claim value** remains `BrightAI_<env>_admin` until Okta is migrated (IdP cutover).
 * Constant name is BrightNav for product naming. Stricter **administration** UI (SPA
 * `/brightnav/admin`) uses {@link BRIGHTNAV_ADMIN_DEVELOPER_OKTA_GROUP} instead.
 */
export const BRIGHTNAV_ADMIN_OKTA_GROUP = `BrightAI_${environment.oktaGroupEnvironment}_admin`;

/**
 * Okta group for the BrightNav **Administration** SPA only (`/brightnav/admin` and its lazy routes).
 * Assign this group to developers who should manage admin-only tools (e.g. chat suggestion CRUD);
 * it is intentionally narrower than {@link BRIGHTNAV_ADMIN_OKTA_GROUP}.
 *
 * @remarks Naming convention: `BrightNav_<env>_admin_developers` (e.g. `BrightNav_dev_admin_developers`).
 * fa-app-service **`BRIGHT_AI_ADMIN_ROLE`** for chat-suggestions admin APIs should match **this**
 * group string if only developers may call those routes.
 */
export const BRIGHTNAV_ADMIN_DEVELOPER_OKTA_GROUP = `BrightNav_${environment.oktaGroupEnvironment}_admin_developers`;
